import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {DecidecompraDetail} from "./decidecompra-detail";

const DecideCompraDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/decidecompras');
    }

    return (
        <DecidecompraDetail id={id} onClose={onClose}/>
    )

});

export default DecideCompraDetailPage;